import { Link } from "react-router-dom";
import { BRAND } from "@/lib/data";

const LOGO_SRC = "/be-easy-cars-logo.png";

export function LogoMark({ size = 48, className = "" }) {
  return (
    <img
      src={LOGO_SRC}
      alt="Be Easy Cars Logo"
      width={size}
      height={size}
      className={`object-contain drop-shadow-[0_6px_20px_rgba(220,38,38,0.45)] ${className}`}
      style={{ height: size, width: "auto" }}
    />
  );
}

export function LogoWordmark() {
  return (
    <Link to="/" className="flex items-center gap-3 group shrink-0" data-testid="brand-logo-link">
      <LogoMark size={54} />
      <div className="hidden sm:flex flex-col leading-none">
        <span className="font-display font-black text-lg lg:text-xl tracking-tight text-white whitespace-nowrap">
          BE EASY <span className="text-red-500">CARS</span>
        </span>
        <span className="hidden md:block text-[9px] uppercase tracking-[0.24em] text-slate-400 mt-1 whitespace-nowrap">
          {BRAND.tagline}
        </span>
      </div>
    </Link>
  );
}
